import * as React from 'react'
import mapStore from '../../store/mapStore.ts'

export const MapTypeToggle: React.FC = () => {
    const map = mapStore(s => s.map)
    const [mapType, setMapType] = React.useState<string>('roadmap')

    React.useEffect(() => {
        if (!map) return
        const listener = map.addListener('maptypeid_changed', () => {
            setMapType(map.getMapTypeId() || 'roadmap')
        })
        setMapType(map.getMapTypeId() || 'roadmap')
        return () => google.maps.event.removeListener(listener)
    }, [map])

    if (!map) return null

    const base = {
        padding: '0 17px',
        height: '40px',
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'Roboto, Arial, sans-serif',
        fontSize: '18px',
        background: 'white',
        minWidth: '66px',
        color: 'rgb(86, 86, 86)',
    } as React.CSSProperties

    const isRoadmap = mapType === 'roadmap'

    return (
        <div style={{ display: 'inline-flex', gap: '2px', boxShadow: 'rgba(0,0,0,0.3) 0px 1px 4px -1px', borderRadius: '2px', overflow: 'hidden' }}>
            <button
                style={{ ...base, fontWeight: isRoadmap ? 500 : 300 }}
                onClick={() => { map.setMapTypeId(google.maps.MapTypeId.ROADMAP); setMapType('roadmap') }}
            >
                Map
            </button>
            <button
                style={{ ...base, fontWeight: !isRoadmap ? 500 : 300 }}
                onClick={() => { map.setMapTypeId(google.maps.MapTypeId.HYBRID); setMapType('satellite') }}
            >
                Satellite
            </button>
        </div>
    )
}
